// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"351":"c8b85f45","377":"5cb49f0c","675":"6c16d0ae"}[chunkId] + ".chunk.js";
};